<template>
    <div class="chart-select">
        <div v-if="loading" class="form-control form-control-sm chart-select-loading">
            <span class="chart-select-spinner"></span>
            <span>{{ $t('AppVehiclesSelectCharts.Aguardando dados') }}</span>
        </div>
        <select v-else class="form-control width-auto-100 form-control-sm" @change="handleChange($event)" v-model="chart_selected">
            <option class="font-select-option" v-for="type in charts_types_data" v-bind:value="type" v-bind:key="type.key">{{type.name}}</option>
        </select>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                chart_selected: this.selected
            }
        },
        methods: {
            handleChange(event) {
                this.$emit('handleSelectChanges', this.chart_selected);
            }
        },
        components: {},
        props: {
            selected: {
                type: Object
            },
            charts_types_data: {
                type: Array,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            selected: {
                handler: function (val) {
                    this.chart_selected = val;
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

    .font-select-option {
        font-size: 15px;
    }

    .chart-select {
        width: 100%;
    }

    .chart-select > select,
    .chart-select-loading {
        width: 100%;
    }

    .chart-select-loading {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #6c757d;
        font-size: 15px;
        cursor: default;
    }

    .chart-select-spinner {
        width: 14px;
        height: 14px;
        border: 2px solid #cbcbcb;
        border-top-color: #0f9af0;
        border-radius: 50%;
        animation: chart-select-spin 0.7s linear infinite;
        flex-shrink: 0;
    }

    @keyframes chart-select-spin {
        to {
            transform: rotate(360deg);
        }
    }

</style>
